export default "__VITE_ASSET__DP7wuVP5__"